module.exports = __webpack_public_path__ + "img/addUp_01.dd9a5b03.png";